module.exports = __webpack_public_path__ + "static/media/habbit-perform.bc9632f3.gif";